import { AppShell } from './AppShell';
import type { NavGroup, NavTabs } from './nav-types';

const GROUPS: readonly NavGroup[] = [
  {
    label: 'Institutes',
    items: [
      { to: '/admin/institutes', label: 'All institutes', icon: 'institutes' },
      { to: '/admin/institutes/queue', label: 'Pending', icon: 'pending' },
    ],
  },
  {
    label: 'Content',
    items: [
      { to: '/admin/tests', label: 'Tests', icon: 'tests' },
      { to: '/admin/email', label: 'Email', icon: 'email' },
      { to: '/admin/speaking-storage', label: 'Speaking storage', icon: 'speaking' },
      { to: '/admin/band-conversion', label: 'Band conversion', icon: 'band', disabled: true },
    ],
  },
  {
    label: 'Platform',
    items: [{ to: '/admin/superadmins', label: 'Superadmins', icon: 'superadmins' }],
  },
  // One row per workspace, in the same slot, because the account block in the
  // sidebar foot is easy to miss on a phone where the drawer scrolls.
  {
    label: 'Account',
    items: [{ to: '/admin/profile', label: 'Profile', icon: 'account' }],
  },
];

// "Institutes" is exact-match so the queue tab is the only one lit on /queue;
// "Admins" rather than "Superadmins" because five slots share 375px.
const TABS: NavTabs = [
  { to: '/admin/institutes', label: 'Institutes', icon: 'institutes' },
  { to: '/admin/institutes/queue', label: 'Queue', icon: 'pending' },
  { to: '/admin/tests', label: 'Tests', icon: 'tests' },
  { to: '/admin/superadmins', label: 'Admins', icon: 'superadmins' },
];

export function AdminLayout(): JSX.Element {
  return (
    <AppShell
      brand="IELTS Mock"
      workspace="Admin"
      profileHref="/admin/profile"
      homeHref="/admin/institutes"
      groups={GROUPS}
      tabs={TABS}
    />
  );
}
